import clsx from 'clsx';

import { IEntityComponentProps } from '~interfaces/props';
import { ColorValue } from '~modules/palette/ColorValue';
import { getTitle } from '~services/entity-helpers';

export interface IColorMainProps extends IEntityComponentProps {
  onClick: (hex: string) => void;
}

export const ColorMain = ({ onClick, data }: IColorMainProps) => {
  if (!data) {
    return null;
  }
  const hex = data.attributes?.field_hex ? data.attributes.field_hex.toUpperCase() : '';
  const cmyk = data.attributes?.field_cmyk;
  const avery = data.attributes?.field_avery;
  const hks = data.attributes?.field_hks;
  const textil = data.attributes?.field_textil;
  const ncs = data.attributes?.field_ncs;
  const ral = data.attributes?.field_ral;
  const rgb = data.attributes?.field_rgb;
  const pantone = data.attributes?.field_pantone;
  const isLight = data.attributes?.field_light_color || false;
  const title = getTitle(data);

  const clsContainer = clsx(
    'c-color__preview u-full-width relative u-padding-top-md',
    {
      'c-color__shade--light': isLight,
    },
    'col col-12',
  );

  const clsSection = 'row';
  const clsHeader = clsx('c-color__title col col-12');
  const clsColorsContainer = clsx('c-color__info u-padding-vertical-sm u-clearfix col col-12');
  const clsColors = clsx('u-full-width d-flex flex-wrap');

  return (
    <div className={clsContainer} style={{ backgroundColor: hex }} onClick={() => onClick(hex)}>
      <div className={clsSection}>
        <div className={clsHeader}>
          <h2 className="h5">{title}</h2>
        </div>
      </div>
      <div className={clsSection}>
        <div className={clsColorsContainer}>
          <div className={clsColors}>
            <ColorValue label="HEX" value={hex} />
            <ColorValue label="RGB" value={rgb} />
            <ColorValue label="CMYK" value={cmyk} />
            <ColorValue label="PANTONE" value={pantone} />
            <ColorValue label="RAL" value={ral} />
            <ColorValue label="NCS" value={ncs} />
            <ColorValue label="AVERY" value={avery} />
            <ColorValue label="TEXTIL" value={textil} />
            <ColorValue label="HKS" value={hks} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorMain;
